import { useReducedMotion } from 'framer-motion';
import PropTypes from 'prop-types';

import AppHeader from '#client/components/AppHeader';
import { DashboardUi } from '#client/directEntry/MFEs';

import * as Styled from './ProductOverlay.style';

const overlayVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
      mass: 0.8
    }
  },
  exit: {
    opacity: 0,
    y: -80,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 25,
      mass: 0.6
    }
  }
};

export default function ProductOverlay({ product, onClose }) {
  const prefersReducedMotion = useReducedMotion();

  if (!product) {
    return null;
  }

  return (
    <Styled.ProductOverlayRoot
      animate={prefersReducedMotion ? undefined : 'visible'}
      exit={prefersReducedMotion ? undefined : 'exit'}
      initial={prefersReducedMotion ? false : 'hidden'}
      variants={overlayVariants}
    >
      <AppHeader title={product.title} onBack={onClose} />
      {product.ctaUrl && (
        <Styled.ProductOverlayContent>
          <DashboardUi
            exportName="ProductLanding"
            federated
            loadingElement={null}
            path={product.ctaUrl}
          />
        </Styled.ProductOverlayContent>
      )}
    </Styled.ProductOverlayRoot>
  );
}

ProductOverlay.propTypes = {
  product: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    imageUrl: PropTypes.string,
    icon: PropTypes.string,
    ctaUrl: PropTypes.string,
    ctaText: PropTypes.string
  }),
  onClose: PropTypes.func.isRequired
};
